import { RouteLinkActionConfig } from './rla-config.model';
import { NgxMaskConfig } from 'ngx-mask/lib/ngx-mask.config';
import { PaymentType } from './quote.model';

export interface PortalFieldConfig {
  label?: string;
  hidden?: boolean;
  disabled?: boolean;
  defaultValue?: unknown;
}

export type PortalFieldConfigDefinition = Record<string, PortalFieldConfig>;
export type FormParser = (model: any) => any;

export interface PortalFormConfig {
  fields?: PortalFieldConfigDefinition;
  parsers?: FormParser[];
}

export interface CurrencyConfig {
  currencyCode?: string;
  display?: string;
  digitsInfo?: string;
  locale?: string;
  mask?: CurrencyConfigMask;
}

export interface CurrencyConfigMask {
  mask: string;
  config: Partial<NgxMaskConfig>;
}

export interface PortalProposalDependenciesConfig {
  contact?: boolean;
}

export interface PortalProposalConfig {
  dependencies: PortalProposalDependenciesConfig;
}

export interface PortalConfig {
  id: number;
  name: string;
  intermediateHome?: boolean;
  formConfig?: Record<string, PortalFormConfig>;
  labels?: Record<string, string>;
  currencyConfig?: CurrencyConfig;
  featureOptions?: any;
  navigation?: Record<string, RouteLinkActionConfig[]>;
  other?: any;
  proposal?: PortalProposalConfig;
  productOverrides?: Record<any, Partial<PortalConfig>>;
  detailsSubFeatures?: DetailsSubFeatures[];
  paymentTypes?: PaymentType[];
  autoSaveInterval?: number; // in minutes
  offlinePaymentPhoneNumber?: string;
}

export type PortalConfigDefinition = Record<number, PortalConfig> & {
  portalsWherePolicyTakesClientBrokers?: any;
};

export enum DetailsSubFeatures {
  Overview = 'overview',
  PracticeDetails = 'practiceDetails',
  Principals = 'principals',
  CommunicationPreferences = 'communicationPreferences',
}
